export const TIPO_PRORRATA_MODELO_390_ENUM = {
  BLANCO: 0,
  G: 1,
  E: 2,
} as const

export type TipoProrrataModelo390EnumType =
  (typeof TIPO_PRORRATA_MODELO_390_ENUM)[keyof typeof TIPO_PRORRATA_MODELO_390_ENUM]
